module.exports = __webpack_public_path__ + "static/media/ac.28200607.png";